import { ReactElement, useCallback, useRef } from "react";
import classNames from "classnames";
import { UiaButton, useUiContext } from "@rotorstudios/fe-ui";

import UiaIconArrowLink from "../../atoms/uiaIconArrowLink/UiaIconArrowLink";
import UiMButtonAR, { iARButton } from "../../../uiModules/uiMButtonAR/UiMButtonAR";
import "./_UimLink.scss";

type UimLinkProps = {
  className?: string;
  tLabel: string;
  right?: boolean;
  left?: boolean;
  noIcon?: boolean;
  primary?: boolean;
  secondary?: boolean;
  gaDataButtonName?: string;
  gaProps?: any;
  ar?: iARButton;
  onClick: () => void;
  qaId?: string;
};

const UimLink = ({
  className = "",
  tLabel,
  right = false,
  left = false,
  primary = false,
  secondary = false,
  gaDataButtonName = "",
  noIcon,
  onClick,
  gaProps,
  ar,
  qaId,
}: UimLinkProps): ReactElement => {
  const { projectClass } = useUiContext();
  const baseRef = useRef(null);

  const getClassName = () => classNames(`${projectClass}_UimLink`, className);

  const getLabelIcon = useCallback(() => {
    const label = <span className={`${projectClass}_UimLink_Label`}>{tLabel}</span>;
    if (noIcon) {
      return <div>{label}</div>;
    }
    if (!left || right) {
      return (
        <div>
          {label} <UiaIconArrowLink right />
        </div>
      );
    }
    return (
      <div>
        <UiaIconArrowLink left /> {label}
      </div>
    );
  }, [projectClass, tLabel, left, right, noIcon]);

  return (
    <div className={getClassName()} ref={baseRef}>
      {ar?.tLabel ? (
        <UiMButtonAR
          secondary
          inverse
          gaProps={gaProps}
          gaDataButtonName={gaDataButtonName}
          ar={ar}
          qaId={qaId}
        />
      ) : (
        <UiaButton
          primary={primary}
          secondary={secondary}
          onClick={onClick}
          gaDataButtonName={gaDataButtonName}
          qaId={qaId}
        >
          {getLabelIcon()}
        </UiaButton>
      )}
    </div>
  );
};

export default UimLink;
